import useGlobalState from '@components/Hooks/useGlobalState';
import Icon from '@Shared/Icon';
import Success from '@Shared/Success';
import React from 'react';

const ChangePasswordSuccess: React.FC = () => {

  const [store,] = useGlobalState();

  return store.change_password?._info.success ? (
    <Success>
      <h2>Password Changed</h2>
      <p><a className='btn btn-success' href='#/'>Go Home <Icon name='arrow-circle-right' /></a></p>
    </Success>
  ) : null;
}

export default ChangePasswordSuccess;